import { Controller } from "stimulus"

export default class extends Controller {
  static values = { rowsElement: String, filter: Object, externalFilter: Object, excludeBlank: Boolean, productNameField: String }
  static get targets() {
    return ['kind', 'countrybrand', 'product', 'metal', 'goldShare', 'template', 'button', 'includeNotMatured'];
  }

  connect(){
    if (this.hasIncludeNotMaturedTarget) {
      $(this.includeNotMaturedTarget).on('click', ()=>{ this.reloadProducts(); });
    }
    if (this.hasProductTarget) {
      $(this.productTarget).on('change', ()=>{ this.productChanged(); });
      this.productChanged();
    }
    if (this.hasExternalFilterValue) {
      _.each(_.values(this.externalFilterValue), (v) => {
        $(v).on('change', ()=>{ this.reloadProducts(); });
      })
    }
  }
  currentProduct(){
    if (this.hasProductTarget) {
      return $(this.productTarget).val();
    }
  }
  productChanged(){
    if (!this.hasButtonTarget) {
      return;
    }
    let button = $(this.buttonTarget);
    if (this.currentProduct()) {
      button.removeClass('disabled');
    } else {
      button.addClass('disabled');
    }
  }
  productOptionName(product){
    if (this.hasProductNameFieldValue) {
      return product[this.productNameFieldValue];
    } else {
      return product.fullname;
    }
  }
  replaceProductTargetOptions(data) {
    let prod = $(this.productTarget);
    prod.empty();
    if (!this.excludeBlankValue) {
      prod.append($('<option>'));      
    }
    _.each(data, (product)=>{
      let prod_option = $('<option>').attr("value", product.id).text(this.productOptionName(product)).data('product', product);
      prod.append(prod_option);
    });
    this.productChanged();
  }
  reloadProducts(event) { 
    let filter = (this.hasFilterValue ? this.filterValue : {});
    if (this.hasExternalFilterValue) {
      let externalFilter = _.mapValues(this.externalFilterValue, (v) => {
        return $(v).val();
      })
      _.assign(filter, externalFilter);
    }
    if (this.hasKindTarget && this.kindTarget.value) {
      filter['kind_eq'] = this.kindTarget.value;
    }
    if (this.hasMetalTarget && this.metalTarget.value) {
      filter['metal_eq'] = this.metalTarget.value;
    }
    if (this.hasGoldShareTarget && this.goldShareTarget.value) {
      filter['gold_share_eq'] = this.goldShareTarget.value;
    }
    if (this.hasCountrybrandTarget && this.countrybrandTarget.value) {
      filter['product_country_brand_id_eq'] = this.countrybrandTarget.value;
    }
    if (this.hasIncludeNotMaturedTarget && $(this.includeNotMaturedTarget).is(':checked')) {
      delete filter['warehouse_reports_quantity_matured_gt']
    }
    $.get( "/products.json", { q: filter } )
     .done(( data )=>{
       this.replaceProductTargetOptions(data);
     });
  }

  addProductRow(event) {
    event.preventDefault();
    if (this.productTarget.value) {
      var contentText = this.templateTarget.innerHTML.replace(/TMPL_ID/g, new Date().valueOf());
      var content = $(contentText);
      var selected = $(this.productTarget).find("option:selected" );
      content.find('.or-product').val(this.productTarget.value).data('product', selected.data('product'));
      content.find('.or-product-name').html(selected.text());
      if (selected.data('product')['quantity']) {
        content.find('.or-quantity').val(selected.data('product')['quantity']);
      }
      $(this.rowsElementValue).append(content);
      content.find('.or-quantity').focus();    
    } else {
      alert('Devi selezionare un prodotto');
    }
  }
}